/**
 * @typedef {import('../types.js').Omission} Omission
 */

import {opening} from './opening.js'
import {closing} from './closing.js'

/** @type {Omission} */
export const omission = {opening, closing}
